var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_4108_2991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40039 2.09961C2.29582 2.09961 1.40039 2.99504 1.40039 4.09961L1.40039 9.89961C1.40039 11.0042 2.29582 11.8996 3.40039 11.8996L10.6004 11.8996C11.705 11.8996 12.6004 11.0042 12.6004 9.89961L12.6004 4.09961C12.6004 2.99504 11.705 2.09961 10.6004 2.09961L3.40039 2.09961ZM3.85039 3.32461L2.80039 3.32461L2.80039 4.37461L3.85039 4.37461L3.85039 3.32461ZM6.12539 8.86515L8.75039 7.34961L6.12539 5.83406L6.12539 8.86515ZM2.80039 5.42461L3.85039 5.42461L3.85039 6.47461L2.80039 6.47461L2.80039 5.42461ZM3.85039 7.52461L2.80039 7.52461L2.80039 8.57461L3.85039 8.57461L3.85039 7.52461ZM2.80039 9.62461L3.85039 9.62461L3.85039 10.6746L2.80039 10.6746L2.80039 9.62461ZM11.2004 3.32461L10.1504 3.32461L10.1504 4.37461L11.2004 4.37461L11.2004 3.32461ZM10.1504 5.42461L11.2004 5.42461L11.2004 6.47461L10.1504 6.47461L10.1504 5.42461ZM11.2004 7.52461L10.1504 7.52461L10.1504 8.57461L11.2004 8.57461L11.2004 7.52461ZM10.1504 9.62461L11.2004 9.62461L11.2004 10.6746L10.1504 10.6746L10.1504 9.62461Z",
    fill: "#605D62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4108_2991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 14) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.d27b2d10c5d6afb636bf4028268b300f.svg";
export { ForwardRef as ReactComponent };